<template>
    <div>
        <el-pagination
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            background
            :small="$store.state.type == 'pc' ? false : true"
            :current-page="page"
            :page-size="listData.page_size"
            :page-sizes="[10,20,40,50]"
            :layout="layout"
            :total="total">
        </el-pagination>
    </div>
</template>
<script>

export default {
    name: 'pagination',
    data() {
        return {
            listData: {
                page_size: 10,
                layout: 'prev, pager, next, total, sizes, jumper',
            }
        }
    },
    props: ['total', 'page'],
    created() {
        if(this.$store.state.type == 'pc') {
            this.layout = 'prev, pager, next, total, sizes, jumper';
        }else{
            this.layout = 'prev, pager, next';
        }
    },
    methods: {
        handleCurrentChange(page) {
            this.listData.page = page;
            this.$emit('paginationChange', this.listData);
        },
        handleSizeChange(size) {
            this.listData.page_size = size;
            this.listData.page = 1;
            this.$emit('paginationChange', this.listData);
        }
    }
}
</script>
<style scoped>
    .el-pagination {
        margin-top: 20px;
    }
</style>


// WEBPACK FOOTER //
// src/components/pagination/pagination.vue